<template>
    <div class="product-form">
        <div class="product-form__name-title">
            <h2>
                <span class="name-title__code">{{ productData.code }}</span>
                -
                <span class="name-title__name">{{ productData.name }}</span>
                -
                <span class="name-title__brand">{{ productData.brand }}</span>
            </h2>
        </div>
        <div class="product-form__body">
            <el-tabs>
                <el-tab-pane label="Product Info">
                    <product-info
                        v-if="active === 'PRODUCT_INFO'"
                        v-bind.sync="productData"
                        :product-data="productData"
                        :is-editing-existing-product="isEditingExistingProduct"
                        :current-supplier-id="currentSupplierId"
                        label="Product Info"
                        @save="$emit('save')"
                    ></product-info>
                </el-tab-pane>
                <el-tab-pane style="height:690px" label="Ordering Info">
                    <div class="product-form__order-method-selector">
                        <h2 style="margin-top: 10px">
                            How do you order the product?
                        </h2>
                        <el-radio-group v-model="productData.type">
                            <el-radio-button label="UNIT" />
                            <el-radio-button label="CARTON" />
                            <el-radio-button label="QUANTITY" />
                        </el-radio-group>
                    </div>
                    <unit-info
                        v-if="productData.type === 'UNIT'"
                        v-bind.sync="productData"
                        :product-data="productData"
                        @prev="prev"
                        @save="$emit('save')"
                    ></unit-info>
                    <package-info
                        v-else-if="productData.type === 'CARTON'"
                        v-bind.sync="productData"
                        :product-data="productData"
                        @prev="prev"
                        @save="$emit('save')"
                    ></package-info>
                    <quantity-product-form
                        v-else-if="productData.type === 'QUANTITY'"
                        v-bind.sync="productData"
                        :product-data="productData"
                        @prev="prev"
                        @save="$emit('save')"
                    ></quantity-product-form>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import FormInput from "Components/FormInput";
import ProductInfo from "./ProductInfo";
import PackageInfo from "./PackageInfo";
import UnitInfo from "./UnitInfo";
import QuantityProductForm from "./QuantityProductForm";

export default {
    components: {
        QuantityProductForm,
        FormInput,
        ProductInfo,
        PackageInfo,
        UnitInfo,
    },
    props: {
        currentSupplierId: String,
        currentProduct: Object,
        isEditingExistingProduct: Boolean,
    },
    data: () => ({
        active: "PRODUCT_INFO",
        rules: {
            code: [
                {
                    required: true,
                    message: "Please input an item code",
                    trigger: "blur",
                },
            ],
            name: [
                {
                    required: true,
                    message: "Please input an item name",
                    trigger: "blur",
                },
            ],
        },

        productData: {
            code: "",
            name: "",
            brand: "",
            type: "",
            unitType: "",
            unitSize: undefined,
            unitOfMeasurement: undefined,
            unitQuantityPerCarton: undefined,
            costPerUnit: undefined,
            groups: [],
        },

        money: {
            decimal: ",",
            thousands: ".",
            prefix: "$ ",
            suffix: "",
            precision: 2,
            masked: false,
        },
    }),

    mounted() {
        if (this.currentProduct._id) {
            this.productData = this.currentProduct;
        }

        this.rules.supplier = [
            { validator: this.checkSupplier, trigger: "blur" },
        ];
    },

    methods: {
        checkSupplier(rule, value, callback) {
            if (!this.productData.supplierId) {
                return callback(new Error("Please select a supplier"));
            }
            return callback();
        },

        prev() {
            this.active = "PRODUCT_INFO";
        },

        next() {
            if (this.productData.type === "UNIT") {
                this.active = "UNIT";
            } else if (this.productData.type === "CARTON") {
                this.active = "PACKAGE";
            } else if (this.productData.type === "QUANTITY") {
                this.active = "QUANTITY";
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables";

.product-form {
    padding: 0 60px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .product-form__name-title {
        align-items: center;
        background-color: $grey;
        border-radius: 4px;
        display: flex;
        height: 40px;
        justify-content: center;
        margin-bottom: 30px;
        text-align: center;
    }

    .product-form__body {
        display: flex;
        flex: 1;
        flex-direction: column;
    }

    /deep/ .el-form-item {
        margin-bottom: 0;
    }
}
.product-form__order-method-selector {
    padding-bottom: 40px;
}
</style>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.1s ease;
}

.fade-enter, .fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}
</style>
